const FormWrapper = ({ children, onSubmit }) => {
  return (
    <form onSubmit={onSubmit}>
      <div className="space-y-12">
        <div className="border-b border-ink-100 pb-12">{children}</div>
      </div>
    </form>
  );
};

export default FormWrapper;
